// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\na.el-button--mini, button.el-button--mini {\n  padding: 7px;\n  margin-bottom: 5px;\n}\n.el-table__cell .el-button+.el-button {\n  margin-left: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
